/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from "react";
import MapActionLinks from "Containers/MapActionLinks";
import { ADADestinations } from "Containers/ADADestinations";
import { ADADirections } from "Containers/ADADirections";
import { Accordion, AccordionItem } from "Components/Accordion";
import { createUseStyles, useTheme } from "react-jss";
import { ADATrails } from "Components/ADATrails";

import styles from "./styles";

interface Props {
  actionButtonsConfig: any;
  defaultActionButtonsConfig: any;
  instName: string;
  originalIMapUrl: string;
  suggestedTrails: any;
  combinedStops: {
    id: number;
    title: string;
    realLat: number;
    realLng: number;
  }[];
}

const ADACampusMap = (props: Props) => {
  // combinedStops will have all the destination/stop related information - description, photos, videos, panos
  // suggestedTrails will have the trails info
  const {
    actionButtonsConfig,
    defaultActionButtonsConfig,
    instName,
    originalIMapUrl,
    combinedStops,
    suggestedTrails,
  } = props;
  const useStyles = createUseStyles(styles);
  const theme = useTheme();
  const classes = useStyles({
    theme,
    ...props,
  });

  return (
    <div className={classes.container}>
      <h1 aria-label={instName} tabIndex={0} className={classes.instName}>
        {instName}
      </h1>
      <p>
        This is the accessible version of interactive map designed specifically
        for users needing extra accessibility features. Feel free to
        {
          // eslint-disable-next-line prettier/prettier
        " "
        }
        <a
          href={originalIMapUrl}
          aria-label="Open the original Interactive Map experience."
        >
          check out the original experience here.
        </a>
      </p>
      <div className={classes.actionLinks}>
        <MapActionLinks
          actionButtonsConfig={actionButtonsConfig}
          defaultActionButtonsConfig={defaultActionButtonsConfig}
          highContrast
          alwaysShowLearnMore
        />
      </div>
      <Accordion>
        <AccordionItem id="directions" title="Directions">
          <ADADirections combinedStops={combinedStops} />
        </AccordionItem>
        <AccordionItem id="trails" title="Trails">
          <ADATrails suggestedTrails={suggestedTrails} />
        </AccordionItem>
        <AccordionItem id="destinations" title="Destinations">
          <ADADestinations combinedStops={combinedStops} />
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default ADACampusMap;
